import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from 'environments-lib';
import { DatasourceFileResponseIntermediate, IEnvironment, IFileDataSourceApiService } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UtilsService } from 'utils-service-lib';

@Injectable({ providedIn: 'root' })
export class SectionFileDatasourceService implements IFileDataSourceApiService {

  constructor(private http: HttpClient, @Inject(ENVIRONMENT) private environment: Partial<IEnvironment>) {
  }

  getFileData(fileDatasourcePath: string[]): Observable<DatasourceFileResponseIntermediate> {
    if (fileDatasourcePath.length !== 3) {
      throw new Error('Invalid fileDatasourcePath. Must consist of workflowConfigId, sectionId, fileName');
    }

    const [workflowConfigId, sectionId, fileName] = fileDatasourcePath.slice(0, 3);
    return this.downloadSectionFile(workflowConfigId, sectionId, fileName).pipe(
      map(blob => {
        return {
          contentType: UtilsService.fileNameToMimeType(fileName),
          fileBinaryData: blob,
          name: fileName
        };
      })
    );
  }

  downloadSectionFile(workflowConfigId: string, sectionId: string, fileName: string): Observable<Blob> {
    const mimeType = UtilsService.fileNameToMimeType(fileName);
    fileName = encodeURIComponent(fileName);
    return this.http.get(`${this.environment.kpHost}/adv2/workflowconfig/${workflowConfigId}/${sectionId}/${fileName}`, {
      responseType: 'blob',
      headers: { accept: mimeType },
    });
  }

  uploadFileToSection(params: Map<string, any>): Observable<HttpResponse<any>> {
    const workflowConfigId = params.get('workflowConfigId');
    const sectionId = params.get('sectionId');
    const file = params.get('file');

    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(`${this.environment.kpHost}/adv2/workflowconfig/${workflowConfigId}/${sectionId}`, formData);
  }

  getSectionFileInfo(request: File | { workflowConfigId: string; sectionId: string; fileName: string }): Observable<any> {
    if (request instanceof File) {
      const formData = new FormData();
      formData.append('file', request);
      return this.http.post<any>(`${this.environment.kpHost}/adv2/workflowconfig/templateinfo/`, formData);
    }

    const fileName = encodeURIComponent(request.fileName);
    return this.http.get<any>(
      `${this.environment.kpHost}/adv2/workflowconfig/templateinfo/` + `${request.workflowConfigId}/${request.sectionId}/${fileName}`
    );
  }

  checkFile(id: string, fileParams?: any): Observable<boolean> {
    throw new Error('Method not implemented.');
  }

  postFile(file: File, fileParams: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  deleteFile(fileParams: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
}
